import { createRoute, redirect } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { billingLeaves } from './billing';
import { staffRoute } from './route';
import { teamLeaves } from './team';

const customerSyncComp = lazyPage(() => import('./pages'), 'StaffCustomerSyncHost');

// /$siteId/staff redirects to the billing page.
const staffIndexRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: '/$siteId/staff',
  beforeLoad({ params }) {
    throw redirect({ to: '/$siteId/staff/manage-billing', params });
  },
});

const staffCustomerSyncRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: '/$siteId/staff/customer-sync',
  component: customerSyncComp,
  staticData: { title: 'staff.customer_sync' },
});

/** Staff family - assemble the staff-only tree (pathless parent + its leaves and sub-groups). */
export const staffTree = staffRoute.addChildren([
  staffIndexRoute,
  ...billingLeaves,
  ...teamLeaves,
  staffCustomerSyncRoute,
]);
